export default {"src":"/_next/static/media/SHX.c2ab10ca.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};